import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

interface WorkViewActionMenuProps {
  workViewId: string;
  anchorEl: HTMLElement;
  handleClose: () => void;
  handleDelete: () => void;
}

const WorkViewActionMenu: React.FC<WorkViewActionMenuProps> = (
  {
    workViewId, anchorEl, handleClose, handleDelete,
  },
) => {
  const navigate = useNavigate();

  const handleEditClicked = () => {
    navigate(`/update-WorkView/?workViewId=${workViewId}`);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={handleClose}
    >
      <MenuItem id="edit-workView-button" onClick={handleEditClicked}>{'Edit'}</MenuItem>
      <MenuItem id="delete-workView-button" onClick={handleDelete}>{'Delete'}</MenuItem>
    </Menu>
  );
};
export default WorkViewActionMenu;
